import { useTheme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import useMediaQuery from '@mui/material/useMediaQuery';
import React from 'react';

import { DataItem } from '~components/DataItem';
import SectionCard from '~components/SectionCard';

type Props = {
  attributes: Record<string, string>;
};

const ContactAttributes = ({ attributes }: Props) => {
  const theme = useTheme();
  const isExtraSmall = useMediaQuery(theme.breakpoints.down('sm'));
  const keys = Object.keys(attributes);

  return (
    <SectionCard title='Contact Attributes'>
      {keys.length > 0 && keys.map((key) => <DataItem stacked={isExtraSmall} title={key} value={attributes[key]} />)}

      {keys.length === 0 && (
        <Typography align='center' variant='body1' component='h1' gutterBottom>
          No recordings found
        </Typography>
      )}
    </SectionCard>
  );
};

export default ContactAttributes;
